export default function transformCurrencyAmount(value: number, originalValue: CurrencyAmount) {
  return originalValue === '' ? undefined : value;
}
